module.exports = __webpack_public_path__ + "static/img/kefu_online.ea95b3f5.png";